import { getClientConfig } from './api/client';

/**
 * Browser telemetry (ADR-0007 frontend amendment). Reads the App Insights
 * connection string from /api/client-config at startup and, when present, loads
 * the App Insights JS SDK with automatic route + AJAX tracking. Same-origin
 * /api/* fetches carry W3C trace context, so a page view and the backend
 * request it triggered share one operation_Id — the identity the backend
 * stamps ties the whole trace to a (tenant, user).
 *
 * No-op when the connection string is empty (dev / E2E) or the config call
 * fails: telemetry never blocks or breaks the app. No PII is captured — route
 * paths carry no personal data and App Insights JS does not autocapture form
 * input.
 */
export async function initTelemetry(): Promise<void> {
  let connectionString: string;
  try {
    ({ appInsightsConnectionString: connectionString } = await getClientConfig());
  } catch {
    return;
  }
  if (!connectionString) return;

  // Lazy-load the SDK only when telemetry is actually configured, so it stays
  // out of the critical-path bundle (and off dev / E2E entirely).
  const { ApplicationInsights } = await import('@microsoft/applicationinsights-web');
  const appInsights = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
    },
  });
  appInsights.loadAppInsights();
  appInsights.trackPageView();
}
